import axios from 'axios'
import { isAuthDeniedError } from './cartRecovery.js'
import { clearSession } from './session.js'

/**
 * A wishlist 401/403 means the shopper the page still shows is gone.
 * Sign them out and skip the product-error capture. Any other failure is captured
 * by the caller-supplied function (captureWishlistError at the call sites).
 * Returns true when the shopper was signed out.
 */
export function handleWishlistFailure(error, options = {}) {
	const { store, axios: http = axios, capture, ...details } = options
	if (isAuthDeniedError(error)) {
		clearSession(store, http)
		return true
	}
	if (typeof capture === 'function') capture(error, { store, ...details })
	return false
}
